// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_normal--wrapper--2aUoF","noInteraction":"_normal--noInteraction--w8puv"};